import React, {ReactNode, useState} from 'react';
import b_ from 'b_';

import {Button, Icon} from 'client/common/components/lego';

import './warning-hint.css';

const b = b_.with('warning-hint');

interface WarningHintProps {
    text: ReactNode;
    closable?: boolean;
    onClose?: () => void;
}

export default function WarningHint(props: WarningHintProps) {
    const {text, closable = false, onClose = () => {}} = props;

    const [isVisible, setIsVisible] = useState(true);

    function handleClose() {
        setIsVisible(false);
        onClose();
    }

    if (!isVisible) return null;

    return (
        <div className={b()}>
            <Icon type='info-orange' className={b('info')} size='xs' />
            <p>{text}</p>
            {closable && (
                <Button
                    size='icon'
                    view='clear'
                    icon={(cls: string) => <Icon className={cls} type='cross' />}
                    className={b('button', {type: 'close'})}
                    onClick={handleClose}
                />
            )}
        </div>
    );
}
